export default "__VITE_ASSET__tggpB$mB__"